import { Typography } from '@one-thd/sui-atomic-components';
import { AuthorizeCard } from '@one-thd/sui-icons';
import React from 'react';

interface PreShipOrderStatusProps {
  children?: React.ReactNode;
}

export const PreShipOrderStatus: React.FC<PreShipOrderStatusProps> = ({
  children,
}) => {
  if (children === undefined) {
    return (
      <div className="sui-flex sui-gap-2 sui-items-center">
        <AuthorizeCard size="small" />
        <Typography variant="body-base" weight="bold">
          Processed
        </Typography>
      </div>
    );
  }
  return <div>{children}</div>;
};
